import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../components/base/Button';

export default function LanguagePage() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState('ar');

  const languages = [
    {
      code: 'ar',
      name: 'العربية',
      flag: '🇸🇦',
      direction: 'rtl'
    },
    {
      code: 'en',
      name: 'English',
      flag: '🇺🇸',
      direction: 'ltr'
    }
  ];

  const handleContinue = () => {
    i18n.changeLanguage(selectedLanguage);
    document.dir = languages.find(lang => lang.code === selectedLanguage)?.direction || 'rtl';
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="px-6 py-4">
          <h1 className="text-xl font-semibold text-gray-900 text-center">
            اختر اللغة / Choose Language
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 px-6 py-8">
        <div className="max-w-sm mx-auto">
          {/* App Logo */}
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-4 mx-auto">
              <i className="ri-car-line text-2xl text-white w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h2 className="text-lg font-medium text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
              سامي عبدالسلام
            </h2>
          </div>

          {/* Language Options */}
          <div className="space-y-3 mb-8">
            {languages.map((language) => (
              <button
                key={language.code}
                onClick={() => setSelectedLanguage(language.code)}
                className={`w-full p-4 rounded-lg border-2 transition-all ${
                  selectedLanguage === language.code
                    ? 'border-blue-600 bg-blue-50'
                    : 'border-gray-200 bg-white hover:border-gray-300'
                }`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                    <span className="text-2xl">{language.flag}</span>
                    <span className="text-lg font-medium text-gray-900">
                      {language.name}
                    </span>
                  </div>
                  {selectedLanguage === language.code && (
                    <i className="ri-check-line text-blue-600 text-xl w-6 h-6 flex items-center justify-center"></i>
                  )}
                </div>
              </button>
            ))}
          </div>

          {/* Continue Button */}
          <Button
            onClick={handleContinue}
            className="w-full"
            size="lg"
          >
            متابعة / Continue
          </Button>
        </div>
      </div>
    </div>
  );
}